// src/config/cdn.js
export const CDN = {
  mindshare: "https://d1ct3zodbaiefe.cloudfront.net", // mindgamedataapi
  tiktok:    "https://dd29pvm79j0ht.cloudfront.net",  // tiktok-scrape
};
